import { tokens } from "./tokens";

/**
 * Flat map of CSS custom property name → value.
 * Naming: `--ax-<category>-<token>` with dots/`/` replaced by `-`.
 */
export function toCssVariables(
  tree: Record<string, unknown> = tokens as unknown as Record<string, unknown>,
  prefix = "--ax",
): Record<string, string> {
  const out: Record<string, string> = {};

  function walk(node: unknown, path: string[]): void {
    if (node === null || node === undefined) return;
    if (typeof node === "string" || typeof node === "number") {
      out[`${prefix}-${path.join("-")}`] = String(node);
      return;
    }
    if (Array.isArray(node)) {
      // weights: emit as comma-separated list under the path
      out[`${prefix}-${path.join("-")}`] = node.join(", ");
      return;
    }
    if (typeof node === "object") {
      for (const [key, value] of Object.entries(node as Record<string, unknown>)) {
        walk(value, [...path, key]);
      }
    }
  }

  walk(tree, []);
  return out;
}

/** `:root { … }` stylesheet string ready to inject or emit as a .css file. */
export function toCssRoot(vars: Record<string, string> = toCssVariables()): string {
  const body = Object.entries(vars)
    .map(([name, value]) => `  ${name}: ${value};`)
    .join("\n");
  return `:root {\n${body}\n}\n`;
}

/** Precomputed CSS custom properties for the finalized token set. */
export const cssVariables = toCssVariables();

/** Precomputed `:root` block. */
export const cssRoot = toCssRoot(cssVariables);
